// components/utils/buildFilterQuery.js
export function buildFilterQuery(filters) {
  const params = new URLSearchParams();

  const add = (key, value) => {
    if (value === null || value === undefined || value === "") return;
    params.append(key, value.id || value);
  };

  add("kategorie", filters.kategorie);
  add("ablageort", filters.ablageort);
  add("typ", filters.typ);
  add("land", filters.land);
  add("material", filters.material);
  add("waehrung", filters.waehrung);
  add("zustand", filters.zustand);
  add("eigentuemer", filters.eigentuemer);

  if (filters.jahrgangMin) params.append("jahrgang_min", filters.jahrgangMin);
  if (filters.jahrgangMax) params.append("jahrgang_max", filters.jahrgangMax);

  return params.toString();
}
